module.exports = __webpack_public_path__ + "static/media/beata-candelaria-san-jose-small.6863c181.jpg";